import { createGlobalStyle } from 'styled-components';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const TooltipGlobalStyles = createGlobalStyle `
.react-tooltip-lite {
  box-sizing: border-box;
  background: ${tokens.colors.midnight[800].value};
  color: ${tokens.colors.white[100].value};
  border-radius: ${tokens.radius.m};
  font-size: ${tokens.font.size.s.value};
  line-height: 1.33;
  font-weight: ${tokens.font.weight.medium.value};
  max-width: 14rem !important;
  word-break: break-word;

  strong {
    font-weight: ${tokens.font.weight.black.value};
  }

  p {
    margin: 0;

    &:not(:first-child) {
      margin-top: 1em;
    }
  }

  a {
    color: ${tokens.colors.emerald[400].value};

    &:hover,
    &:active {
      color: ${tokens.colors.indigo[500].value};
    }
  }

  ul, ol {
    margin-left: 0;
    padding-left: 1rem;
  }
}

.react-tooltip-lite-arrow {
  border-color: ${tokens.colors.midnight[800].value};
  transform: scale(1.2);
}

.tooltip__left .react-tooltip-lite {
  text-align: left;
}

.tooltip__right .react-tooltip-lite {
  text-align: right;
}

.tooltip__center .react-tooltip-lite {
  text-align: center;
}
`;
//# sourceMappingURL=Tooltip.styled.js.map